@if (hasEntitlements) {
  <div>
    Redirecting you to the Benefits Manager website.
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <div class="loading-container warning-message">
    {{ noEntitlementsMessage || 'Your currently selected agency does not have access to the Benefits Manager SSO.
    Try a different agency if available.'}}
  </div>
}
